"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var util_1 = require("../util");
var ChatTyping = function (props) {
    var _a = (0, util_1.getVariantClassNames)(props), primary = _a.primary, secondary = _a.secondary;
    return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M36.6667 25V32.6667C36.6667 33.5833 35.9167 34.3333 35 34.3333C34.5833 34.3333 34.1667 34.1667 33.8333 33.8333L30 30H10C7.25 30 5 27.75 5 25V10C5 7.25 7.25 5 10 5H31.6667C34.4167 5 36.6667 7.25 36.6667 10V25Z", className: primary }),
        react_1.default.createElement("path", { d: "M12.5 20C11.0833 20 10 18.9167 10 17.5C10 16.0833 11.0833 15 12.5 15C13.9167 15 15 16.0833 15 17.5C15 18.9167 13.9167 20 12.5 20ZM20.8333 20C19.4167 20 18.3333 18.9167 18.3333 17.5C18.3333 16.0833 19.4167 15 20.8333 15C22.25 15 23.3333 16.0833 23.3333 17.5C23.3333 18.9167 22.25 20 20.8333 20ZM29.1667 20C27.75 20 26.6667 18.9167 26.6667 17.5C26.6667 16.0833 27.75 15 29.1667 15C30.5833 15 31.6667 16.0833 31.6667 17.5C31.6667 18.9167 30.5833 20 29.1667 20Z", className: secondary })));
};
exports.default = ChatTyping;
